<template>
    <div class="productsPageCon">

     
         <Card v-show="offModel">
            <div class="top flexBC">
                <div>
                     <Button  v-if='roleType==1 && showChildrenSide' type="success" class="addButton" @click="addData(1)" style="margin-right:8px;">{{$t("productPage.addBox.title")}}</Button>
                </div>
            </div>
            <div>
                <Table style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom"  @on-selection-change="selectChange" @on-select-all="selectChange" :loading='loading'></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
            </div>
        </Card>

         <!-- 详情 -->
        <detailModelBox :showModel.sync="detailBox.showModel"   :editFormData="detailBox.editFormData" :fn1="clearbtnStatus"></detailModelBox>

        <!-- 新增、编辑 -->
        <ModelBox :showModel.sync="addBox.showModel" :type="type"  :editFormData="addBox.editFormData" :fn="addBox.callbackFn" :fn1="clearbtnStatus"></ModelBox>


        <!-- 删除 -->
        <DeleteDialog ref="deleteChild" @ievent = "ievent"   :fn1="clearbtnStatus"></DeleteDialog>


    </div>
   
</template>

<script>

import common from '@/common/common.js';
import detailModelBox from './component/detailModel';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import ModelBox from './component/addModel'; // 引入删除弹框组件
import moment from 'moment'
import { mapState } from 'vuex'
import qs from 'qs'
import {Message} from 'iview'

    export default {
        name: "productsAdmin",
        components: {
            detailModelBox,
            DeleteDialog,
            ModelBox
        },
        data(){
            return{
                loading: true,
                offModel: true,
                type:1,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'createDate',
                    order:'desc'
                },
                buttonList: {
                  downDisabled: true, //下载按钮是否禁用
                },
                tableList:{
                    tableDataAll:[],
                    tableData:[],
                    hasSelectData:{}
                },
                detailBox:{//规格弹框组-详情
                    showModel:false,//弹框开关
                    editFormData:{},//编辑时传入的现有数据
                },
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                }
            }
        },
        computed:{
            ...mapState(['selectId','uInfo','showChildrenSide']),
            roleType(){
	        	 let res = '2'
	        	 if(this.uInfo && this.uInfo.roleType){
	        		 res = this.uInfo.roleType
	        	 }
	        	 return res
	         },
            titleName(){
                return [
                    //  {
                    //   type: "selection",
                    //   width: 60,
                    //   align: "center",
                    //   fixed: "left",
                    // },
                    {
                        title: this.$t('productPage.titleName.uiCode_id'),
                        key: 'uiCode',
                        width: 120,
                        sortable: true
                    },
                    {
                        title: this.$t('productPage.titleName.type'),
                        key: 'uiModuleType',
                        width: 120,
                        sortable: true,
                       render:(h, params)=>{
                            let stext = params.row.uiModuleType==2?this.$t('BasicProduct.funcBox.titleName.UIcontroller'):this.$t('BasicProduct.funcBox.titleName.conditionalControl')
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                   
                     {
                        title: this.$t('productPage.titleName.Photos'),
                        width: 100,
                        render: (h, params) => {
                            return  h('div', {
					                    props: {
                                            type: "primary",
                                            size: 'small'
                                        },
                                        style:{
                                            color:'#4ABAF0',
                                            cursor:'pointer'
                                        },
					                    on: {
					                        click: () => { this.showDetail(params.row) }
					                    }
					                },this.$t('productPage.titleName.View'))
                        }
                    },
                    {
                        title: this.$t('productPage.titleName.Description'),
                        key: 'description',
                        minWidth: 200,
                        render:(h, params)=>{
                            let stext = params.row.description
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
                        title: this.$t('productPage.titleName.Remark'),
                        key: 'remark',
                        minWidth: 220
                    },
                   
                    {
                        title: this.$t('productPage.titleName.Date_created'),
                        key: 'createDate',
                        width: 170,
                        render:(h, params)=>{
                            let stext = moment(params.row.createDate*1).format('YYYY-MM-DD HH:mm:ss')
                             return h('div',stext || '')
                        }
                    },
                    {
		            	title: this.$t('productPage.titleName.Operation'),
                        'title-zh-CN':'操作',
                        'title-en-US':'Operation',
                        // fixed:'right',
		            	width:240,
                        key: "Operation",
		            	render: (h, params) => {
                            let that = this
                            return h('div',{
                                style:{
                                    display:'flex',
                                    'justify-content':'center'
                                }
                            },[
                                h('Button',{
		            	              props: {
                                          type: "primary",
                                          size: 'small'
                                      },
                                      style:{
                                        'margin-right':'8px',
                                        'display':(this.roleType==1  && this.showChildrenSide)?"block":"none"
                                      },
		            	              on: {
		            	                  click: () => { 
                                               if(this.roleType==1){
                                                   this.tableList.hasSelectData = params.row
                                                   this.addData(2)
                                               }
                                           }
		            	              }
		            	          },that.$t("edit")),
                                h('Button',{
		            	              props: {
                                          type: "error",
                                          size: 'small'
                                      },
                                      style:{
                                          'display':(this.roleType==1  && this.showChildrenSide)?"block":"none",
                                          'margin-right':'8px',
                                      },
		            	              on: {
		            	                  click: () => { 
                                              if(this.roleType==1){
                                                  this.todelData(params.row)
                                              }
                                           }
		            	              }
		            	          },that.$t("delete"))
                            ])
		            	}
                    }
                    
                ]
             } 
        },
        mounted(){
        },
        created(){
            this.getData()
        },
        watch: {
            // showModel(val){
            //     if(val === false) {   
            //         this.clearbtnStatus()
                  
            //     }
            // },
            // showModel(val){
            //     if(val === false) {   
            //         this.offModel()
                  
            //     }
            // },
        },
        methods: {
            searchItem(){

            },
            showDetail(row){
                this.detailBox.showModel = true
                this.detailBox.editFormData = row
            },
            todelData(item) {// 解绑
                this.tableList.hasSelectData = item
                this.$refs.deleteChild.showit();
            },
            ievent() {// 解绑
                // console.log('删除，下面注释掉了',this.tableList.hasSelectData)
                this.axios.post(this.config.urlArray.delModule, {id:this.tableList.hasSelectData.id}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    // common.msg('error','删除失败')
                })
            },
            addData(type) {  //添加或编辑数据
                this.addBox.showModel = true
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = this.tableList.hasSelectData
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
           
            getData(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order,
                        // dealerId:this.selectId
                    }
                }
                this.axios.post(this.config.urlArray.getModuleList,getData.params).then((result) => {
                    
                    common.ajaxMsg(result.data,false,()=>{

                         let resData = result.data.data
                        //处理数组
                        // if(resData){
                        //     this.tableList.tableData = resData  //渲染数据
                        //     this.page.total = result.data.data.length
                        //     this.loading = false
                        // }else{
                        //     return false
                        // }

                        if (resData) {
                            if (!resData.meta) {//无分页
                              
                              this.tableList.tableDataAll = resData;
                              this.paging = false;
                              this.page.total = result.data.data.length;
                              this.getData1();
                            } else {
                              this.tableList.tableData = resData  //渲染数据
                               this.page.total = result.data.data.length
                               this.loading = false
                               }
                
                            this.loading = false;
                          } else {
                            this.tableList.tableData = [];
                            this.page.total = 0;
                            this.loading = false;
                            return false;
                        }
    
                    });
                   
                })
            },
            getData1() {
              let start = (this.page.current - 1) * this.page.pageSize;
              let end = this.page.current * this.page.pageSize;
              let key = this.page.key;
              let order = this.page.order;
        
            //   this.tableList.tableDataAll = this.filterData([
            //     ...this.tableList.tableDataAll,
            //   ]);
        
              this.page.total = this.tableList.tableDataAll.length;
        
              this.tableList.tableDataAll = this.tableList.tableDataAll.sort((a, b) => {
                if (order == "asc") {
                  return a[key] - b[key];
                } else if (order == "desc") {
                  return b[key] - a[key];
                }
              });
              this.tableList.tableData = this.tableList.tableDataAll.slice(start, end);
            },
            downLoadLang(flag){//语言包下载
                // console.log('this.tableList.hasSelectData',this.tableList.hasSelectData)
                let resArr = []
                if(flag==1){
                    this.tableList.hasSelectData.map((item)=>{
                        resArr.push({
                            dealerId:this.selectId,
                            pageId:item.pageId
                        })
                    })
                }else{
                    this.tableList.tableDataAll.map((item)=>{
                        resArr.push({
                            dealerId:this.selectId,
                            pageId:item.pageId
                        })
                    })
                }
                let aaa = qs.stringify({"jsonStr":JSON.stringify(resArr)})

                this.axios.post(this.config.urlArray.LangPackageDownload, aaa).then((result)=>{
                    // console.log('result',result)
                    // common.ajaxMsg(result.data,true,()=>{
                    //     this.clearbtnStatus()
                    // })

                    if(!result){
                        Message.error({
                          content:'Error: Network Error',
                        })
                        return
                    }

                    this.downloadFile(result);

                })
            },
            downloadFile(result) {//文件下载


              let blob = new Blob([result.data], {type: 'application/zip'})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a') // 创建a标签
              link.href = url

              let disposition = result.headers["content-disposition"]

              if(disposition && disposition.indexOf('filename')){
                  link.download = disposition.slice(disposition.indexOf('filename')+9,disposition.indexOf('.zip')) // 重命名文件
              }else{
                  link.download = `LanguagePack${new Date().getTime()}` // 重命名文件
              }

              link.click()
              URL.revokeObjectURL(url) // 释放内存
            },
            selectChange(res) {//控制编辑和删除按钮的可用状态
      
            //  console.log(res,'44')
             if (res.length) {
               this.buttonList.downDisabled = false;
               this.tableList.hasSelectData = res;
             } else if (res.length == 0) {
               this.buttonList.downDisabled = true;
               this.tableList.hasSelectData = {};
             }
           },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
            clearbtnStatus() {//删除后清空编辑数据 与按钮状态
              this.$refs.selection.selectAll(false);
              this.buttonList.downDisabled = true;
              this.tableList.hasSelectData = {};
            },
        }
    }
</script>

<style lang="less" scoped>
  .productsPageCon{
    margin: 42px 40px 8px;
  }
  .ivu-card-bordered{
    border: none;
  }
</style>



